import CheckBoxInput from "../../../../utils/CheckBoxInput";
import React from "react";
import { Controller } from "react-hook-form";
import { t } from "i18next";
import RegulaminListCheckboxes from "./RegulaminListCheckboxes";

export const userPayCheckboxForm = (errors: any, control: any, setValue: any) => [
  <Controller
    name={"acceptEAktywni"}
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CheckBoxInput
        name={"acceptEAktywni"}
        field={field}
        title={
          <span>
            *{t("akceptuje")} {""}
            <a target="_blank" rel="noreferrer" href={"https://eaktywni.pl/regulamin/"}>
              {t("regulamin")}
            </a>
            {""} {t("serwisu")} eAktywni.pl.
          </span>
        }
        errors={errors}
      />
    )}
  />,
  <Controller
    name={"acceptPrivacyPolicy"}
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CheckBoxInput
        name={"acceptPrivacyPolicy"}
        field={field}
        title={
          <span>
            *{t("akceptuje")} {""}
            <a target="_blank" rel="noreferrer" href={"https://eaktywni.pl/polityka-prywatnosci/"}>
              {t("polityke_prywatnosci")}.
            </a>
          </span>
        }
        errors={errors}
      />
    )}
  />,
  <RegulaminListCheckboxes errors={errors} control={control} setValue={setValue} />,
];
